/**
 * Base URL for the SVG → embroidery Cloud Run service.
 *
 * In development, requests go through the webpack dev-server proxy at `/embroidery-converter`
 * (see craco.config.js) so the browser stays same-origin with the app. That avoids CORS
 * preflight to Cloud Run, which was timing out when the service scaled to zero.
 *
 * Override with REACT_APP_EMBROIDERY_SERVICE_URL for a custom deployment.
 */
const PRODUCTION_URL = "https://embroidery-converter-1034477093602.us-central1.run.app";

export function getEmbroideryServiceUrl() {
  const fromEnv = process.env.REACT_APP_EMBROIDERY_SERVICE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "/embroidery-converter";
  }
  return PRODUCTION_URL;
}
